import * as React from 'react';
import i18next from 'i18next';
import { Columns, Column, Footer, LevelItem, LevelLeft, LevelRight } from 'bloomer';
import { withTranslation, WithTranslation } from 'react-i18next';
import styled from 'styled-components';
import { colors } from '../../styles/colors';

class FooterBar extends React.PureComponent<WithTranslation> {

  render() {

    return (
      <FooterContainer>
        <Columns>
          <Column>
            <LevelLeft>
              <LevelItem>
                <a href={`mailto:${i18next.t('footer.emailAddress')}`} target="_top">{i18next.t('footer.emailAddress')} </a>
              </LevelItem>
            </LevelLeft>
          </Column>
          <Column>
            <LevelRight>
              <LevelItem>
                {/* <a href="tel:+85222109588">{i18next.t('footer.footer')}</a>  */}
              </LevelItem>
            </LevelRight>
          </Column>
        </Columns>
      </FooterContainer>
    );
  }

}

const FooterContainer = styled(Footer)`
    padding: 0 1em;
    background:${colors.grey};
`;

export default withTranslation()(FooterBar);